import { AsyncThunkAction } from 'actions/actions.types'
import { saveStateToSessionStorage } from 'common/store/sessionStorage'

/**
 * store.subscribe
 * срабатывает как то выборочно с async и sync событиями.
 * Поэтому мы руками сохраняем state для rating
 * срабатывает после изменения массивов фото.
 */
export const saveStorageAction = (): AsyncThunkAction => (_, getState) => {
  const state = getState()

  saveStateToSessionStorage(state)

  return null
}
